import React, { useEffect } from "react";
import "../styles/content.style.scss";
import "../styles/contact.style.scss";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
//import { WhatsApp } from "@mui/icons-material";
//import {blurhash } from 'react-blurhash'
//import { encode } from 'blurhash';
function Contact() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  const location = useLocation();
  //blurhash.getImageData()
  function handleSubmit(e) {
    e.preventDefault();
    const encodedMessage = encodeURIComponent(e.target["message"].value);
    if (e.target["email"].value === "") {
      const phoneNumber = "691891212"; // Replace with the phone number you want to send the message to
      const whatsappLink = `https://wa.me/${phoneNumber}/?text=${encodedMessage}`;
      window.open(whatsappLink, "_blank");
    } else {
      const mailtoUrl = `mailto:${
        e.target["email"].value
      }?subject=${encodeURIComponent(
        "Interessé par ce produit"
      )}&body=${encodedMessage}`;
      window.open(mailtoUrl, "_blank");
    }
  }
  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>Contact | GI</title>
        <link
          rel="canonical"
          href="https://www.generalite-informatique.vercel.app/conctact"
        />
        <meta property="og:title" content="Généralité informatique" />
      </Helmet>
      <div className="App top-ctn">
        <div className="ctn-content">
          <div className="contact-form">
            <div className="ctn-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3937.143011271523!2d13.401245812973979!3d9.320593965136567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x10fcc831120a3891%3A0x1ddfa91b37019450!2sGeneralit%C3%A9%20Informatique!5e0!3m2!1sen!2sug!4v1687571790747!5m2!1sen!2sug"
                title="map"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <form
              action=""
              method="post"
              data-aos="fade-up"
              onSubmit={handleSubmit}
            >
              <h1 className="header head-title">Nous Contactez</h1>
              <span>Explorez le futur avec nous</span>
              <span>Restez en securite grace a notre service</span>
              <div className="wrapper">
                <WhatsAppIcon />
                <span className="tel">(+237) 691891212</span>
              </div>
              <label htmlFor="nom">Nom</label>
              <input
                type="text"
                name="nom"
                id="nom"
                placeholder="votre nom"
                required
              />
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="email@gmail.com (non obligatoire)"
              />
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                name="phone"
                id="phone"
                placeholder="+237 XX XX XX XX"
              />
              <label htmlFor="message">Message</label>
              <textarea
                defaultValue={
                  location.state !== null ? location.state.message : ""
                }
                name="message"
                id="message"
                cols="30"
                rows="10"
                placeholder="comment pouvons-nous nous ameliorez ?"
                required
              ></textarea>
              <button type="submit" className="btn-btn">
                Envoyer
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
